export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/array.js
// module id = 28
// module chunks = 0